module.exports = __webpack_public_path__ + "img/logo-nav.6c127d34.png";